import { render } from "./adminLoginView.vue?vue&type=template&id=27037a02"
import script from "./adminLoginView.vue?vue&type=script&lang=js"
export * from "./adminLoginView.vue?vue&type=script&lang=js"

import exportComponent from "E:\\coding\\pharaoh_frog_barber\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__